import React, { useEffect } from 'react'
import { generatePath, Navigate } from 'react-router'

import { PATHS } from '../constants/paths'
import { useGenericStorage } from '../data/GenericStorageContext'
import { useRequest } from '../hooks/request'
import { internshipCreate, internshipCreatePath } from '../requests/internship'

import { PageTitle } from './common/PageTitle'
import { IntershipForm } from './IntershipForm'
import { PageContent } from './layout/layout'

const initial = {
  deputiesIds: [],
}

export const InternshipCreate = () => {
  const { genericStorage, mergeIntoGenericStorage } = useGenericStorage()
  const { internshipToDuplicate } = genericStorage
  const initialValues = internshipToDuplicate || initial
  useEffect(() => () => mergeIntoGenericStorage({ internshipToDuplicate: null }), [])
  const documentCreateRequest = useRequest({
    request: internshipCreate,
  })

  const createSuccess = documentCreateRequest.state.success
  const success = createSuccess
  const newDocument = documentCreateRequest.state.data

  return (
    <>
      <PageTitle tradId="internshipCreate" backLink={PATHS.INTERNSHIP_LIST} backLinkTrad="internshipList" />
      <PageContent>
        {
          success ? (
            <Navigate to={generatePath(PATHS.INTERNSHIP_EDIT, { id: newDocument.id })} push />
          ) : (
            <IntershipForm
              initialValues={initialValues}
              onSubmit={documentCreateRequest.fetch}
              path={internshipCreatePath}
              loading={documentCreateRequest.state.loading}
            />
          )
        }
      </PageContent>
    </>
  )
}
